import { AssetSearchRequest, getSearchFilterValue } from 'owa-timestream-asset-search';
import { invokeSearch } from 'owa-timestream-3s-search';
import { SearchScenarioId, getScenarioStore } from 'owa-search-store';
import { getPageContext } from 'owa-search-service';
import { MailAssetFilterSearchOption } from './filterAssets';
import type { OwaDate } from 'owa-datetime';

export default function searchAsset(searchRequest: AssetSearchRequest): void {
    let searchStore = getScenarioStore(SearchScenarioId.Spaces);
    const { queryString, includesPeopleSuggestion, filters } = searchRequest;

    const includeOnlyItemsWithAttachments = getSearchFilterValue(
        filters,
        MailAssetFilterSearchOption.Attachments
    ) as boolean;
    const includeDeletedItems = getSearchFilterValue(
        filters,
        MailAssetFilterSearchOption.DeletedItems
    ) as boolean;
    const folderId = getSearchFilterValue(filters, MailAssetFilterSearchOption.Folders) as string;
    const fromDate = getSearchFilterValue(filters, MailAssetFilterSearchOption.FromDate) as OwaDate;
    const toDate = getSearchFilterValue(filters, MailAssetFilterSearchOption.ToDate) as OwaDate;

    invokeSearch(
        getPageContext(0),
        searchStore.searchSessionGuid,
        searchStore.currentSearchQueryId,
        queryString,
        'Message',
        'Asc',
        true /* boundSearchResultCount */,
        !!includesPeopleSuggestion,
        includeOnlyItemsWithAttachments,
        includeDeletedItems,
        folderId ? [folderId] : [],
        fromDate,
        toDate
    );
}
